module.exports = "---\r\nurl: \"https://petstore.swagger.io/v2/swagger.json\"\r\ndom_id: \"#swagger-ui\"\r\nvalidatorUrl: \"https://online.swagger.io/validator\""


//////////////////
// WEBPACK FOOTER
// ./swagger-config.yaml
// module id = 520
// module chunks = 0